import { toast as sonner } from "sonner";

/**
 * "Saved" and its kin (decided with Tiago 12 October): a short line that
 * rises above the tab bar for a few seconds and goes, the same for every
 * save, in the same place. An action calls `toast` once what it did has
 * worked; an error is never a toast — it stays beside the box it is about.
 *
 * Drawn by shadcn's sonner (`components/ui/sonner`, which the root layout
 * places). A module rather than a hook, because actions run outside React;
 * it remembers what it last said, which is what the tests read.
 */

export type Toast = { id: number; message: string };

/** How long one stays, in milliseconds. */
export const TOAST_MS = 3000;

/** One line at a time: each toast takes the same place, replacing the last. */
const SONNER_ID = "saved";

let current: Toast | null = null;
let nextId = 1;
let timer: ReturnType<typeof setTimeout> | undefined;

/** Says something worked. A newer one replaces the one showing. */
export function toast(message: string) {
  current = { id: nextId++, message };
  clearTimeout(timer);
  timer = setTimeout(forget, TOAST_MS);
  sonner.success(message, { id: SONNER_ID, duration: TOAST_MS });
}

export function dismissToast() {
  forget();
  sonner.dismiss(SONNER_ID);
}

function forget() {
  clearTimeout(timer);
  current = null;
}

export function currentToast(): Toast | null {
  return current;
}
